export const GEO_GROUPING: {[keys: string]: string[]} = {};

export const FLOW_NAME_BY_GEO: { [keys: string]: { [keys: string]: string }} = {
  default: {
    GBR: 'default_redirect'
  },
  default_registration: {
    GBR: 'default_registration_redirect'
  }
};
